import React, { useEffect, useState } from "react";
import "./Elements.css";
import { Flex, Header, SafeArea } from "../../components/layout";
import { Image, ImageViewer } from "../../components/ui";

import FireImage from "../../assets/images/elements/feu.webp";
import WaterImage from "../../assets/images/elements/eau.webp";
import AirImage from "../../assets/images/elements/air.webp";
import EarthImage from "../../assets/images/elements/terre.webp";
import { useParams } from "react-router-dom";
import { slugify } from "../../function";

function Elements() {
  const [active, setActive] = useState(false);
  const [image, setImage] = useState({});

  const { id } = useParams();

  useEffect(() => {
    const images = [
      { image: FireImage, name: "Feu" },
      { image: WaterImage, name: "Eau" },
      { image: AirImage, name: "Air" },
      { image: EarthImage, name: "Terre" },
    ];
    // id == feu ou eau ou air ou terre
    const image = images.find((image) => slugify(image.name) === slugify(id));
    setImage(image);
  }, [id]);

  return (
    <SafeArea className="Elements">
      <Flex type="col-center" gap={80}>
        <Header
          title={`Élément ${
            image && Object.keys(image).length > 0 && image.name
          }`}
        />
        <Flex>
          <Flex type="center" gap={20} wrap className="content">
            {image && Object.keys(image).length > 0 && (
              <Image
                src={image.image}
                alt={image.name}
                data-text={image.name}
                onClick={() => setActive(true)}
              />
            )}
          </Flex>
        </Flex>
      </Flex>
      {active && (
        <ImageViewer
          images={[image.image]}
          closeViewer={() => setActive(false)}
        />
      )}
    </SafeArea>
  );
}

export default Elements;
